import userType from '../type/personType';
import quoteGQLString from '../util/quoteGQLString';

export default (email) => `
    userByEmail (email: ${quoteGQLString(email)}) {
        ${userType()}
    }
`;
